<script setup lang="ts">
import type { MediaItem } from '~/stores/interfaces'

const { mediaItem } = defineProps<{
  mediaItem: MediaItem
}>()

const isPlaying = ref(false)
const videoRef = ref<HTMLVideoElement | null>(null)

const emit = defineEmits<{
  play: []
}>()

function onPlay() {
  isPlaying.value = true
  emit('play')
}

function playVideo() {
  if (videoRef.value) {
    videoRef.value.play()
    onPlay()
  }
}

const isGif = computed(() => mediaItem.type === 'gif')
const shouldAutoplay = computed(() => isGif.value)
const shouldLoop = computed(() => isGif.value)
const shouldShowControls = computed(() => !isGif.value)
</script>

<template>
  <div class="relative w-full">
    <div class="video-container">
      <video
        ref="videoRef"
        class="w-full rounded-lg relative z-10 object-contain"
        :src="mediaItem.src"
        :controls="shouldShowControls"
        :autoplay="shouldAutoplay"
        :loop="shouldLoop"
        :muted="isGif"
        preload="metadata"
        @play="onPlay"
      >
        Your browser does not support the video tag.
      </video>
    </div>

    <div v-show="!isPlaying && !isGif" class="absolute inset-0 z-20">
      <NuxtImg
        :src="mediaItem.cover_photo"
        alt="Video cover"
        class="w-full h-full object-cover rounded-lg"
      />
      <div class="absolute inset-0 bg-black/30 rounded-lg" />
      <button
        class="absolute inset-0 flex items-center justify-center text-white"
        @click="playVideo"
      >
        <Icon name="heroicons:play" class="h-12 w-12" />
      </button>
    </div>
  </div>
</template>

<style scoped>
.video-container {
  width: 100%;
  position: relative;
  background: black;
}

video {
  display: block;
  max-height: 90vh;
  margin: 0 auto;
}
</style>
